import Swiper from "swiper";

if (window) window.Swiper = Swiper;
// This might log an error due to esbuild transpiling the code to check global weirdly.
// However, if we are still on Gulp, it should work.
if (global) global.Swiper = Swiper;
